import { useNavigate } from "react-router-dom";
import useAuth from "../../../../hook/useAuth";
import { useState } from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";
import axios from "axios";
import { baseURL } from "../../../../config/api";

export const AddTerminal = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const [name, setName] = useState<string>("");
    const [locationId, setLocationId] = useState<string>("");
    const [ipAddress, setIpAddress] = useState<string>("");
    const [deviceId, setDeviceId] = useState<string>("");
    const [isActive, setIsActive] = useState<boolean>(false);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);
        await axios
            .post(
                `${baseURL}terminalDevices?userId=${auth?.id}`,
                JSON.stringify({
                    name,
                    locationId,
                    ipAddress,
                    terminalDeviceId: deviceId,
                    isActive

                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }
    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Add Terminal</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={name}
                                                placeholder="Name"
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">IpAddress</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={ipAddress}
                                                placeholder="IpAddress"
                                                onChange={(e) => setIpAddress(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className={`block text-xs font-medium text-[#667085]`}>IsActive?</label>
                                            <RadioGroup
                                                row
                                                value={isActive ? "Yes" : "No"}
                                                onChange={(e) => setIsActive(e.target.value === "Yes")}
                                            >
                                                <FormControlLabel
                                                    value="Yes"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "blue",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="Yes"
                                                    sx={{
                                                        color: "#2f3739",
                                                    }}
                                                />

                                                <FormControlLabel
                                                    value="No"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "blue",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="No"
                                                    sx={{
                                                        color: "#2f3739",
                                                    }}
                                                />
                                            </RadioGroup>
                                        </div>

                                    </div>

                                    {/* Second Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Location Id</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={locationId}
                                                placeholder="Location Id"
                                                onChange={(e) => setLocationId(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Device Id</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={deviceId}
                                                placeholder="Device Id"
                                                onChange={(e) => setDeviceId(e.target.value)}
                                                required
                                            />
                                        </div>

                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}